@if (previewItem()) {
  <div
    class="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center p-4"
    (click)="onBackdropClick()"
  >
    <!-- Close button -->
    <button
      type="button"
      (click)="closePreview()"
      class="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors cursor-pointer z-10"
    >
      <lucide-icon [img]="icons.X" class="w-6 h-6"></lucide-icon>
    </button>

    <!-- Content container -->
    <div
      class="relative max-w-full max-h-full flex items-center justify-center"
      (click)="onContentClick($event)"
    >
      @if (isPdf(previewItem()!.mimeType)) {
        <!-- PDF preview using browser's native viewer -->
        <object
          [data]="safePdfUrl()"
          type="application/pdf"
          class="w-[90vw] h-[85vh] max-w-4xl rounded-lg bg-white"
        >
          <!-- Fallback if browser can't display PDF inline -->
          <div class="bg-white rounded-2xl p-8 flex flex-col items-center">
            <lucide-icon
              [img]="icons.FileText"
              class="w-16 h-16 text-gray-500 mb-4"
            ></lucide-icon>
            <p class="text-gray-900 font-medium text-center max-w-xs truncate">
              {{ previewItem()!.fileName }}
            </p>
            <p class="text-gray-500 text-sm mt-2">
              <a
                [href]="previewItem()!.url"
                target="_blank"
                rel="noopener noreferrer"
                class="text-violet-600 hover:underline"
              >
                Open PDF in new tab
              </a>
            </p>
          </div>
        </object>
      } @else {
        <!-- Image preview -->
        <img
          [src]="previewItem()!.url"
          [alt]="previewItem()!.fileName"
          class="max-w-full max-h-[85vh] object-contain rounded-lg"
        />
      }
    </div>

    <!-- Filename at bottom -->
    <p class="text-white/80 text-sm mt-4 text-center truncate max-w-full px-4">
      {{ previewItem()!.fileName }}
    </p>
  </div>
}
